<script>
  import TaskDetail from './TaskDetail.svelte';

  import TaskTemplatesModal from './TaskDashboard/TaskTemplatesModal.svelte';
  export let comeFrom = '';
  import { Modal } from 'bootstrap';
  import { getContext, onMount } from 'svelte';
  let addTaskModal;
  let addTaskDetail;
  export const show = (params) => {
    addTaskModal = new Modal(document.getElementById('addTaskModal'), {
      keyboard: false,
      backdrop: 'static',
    });
    addTaskModal.show();
    addTaskDetail.show(0, comeFrom, params);
  };
  const keyboardListnerStatus = getContext('keyboardListnerStatus');
  onMount(() => {
    document.getElementById('addTaskModal').addEventListener('hidePrevented.bs.modal', function () {
      setTimeout(() => {
        hide('manual');
      }, 100);
      return false;
    });
    document.getElementById('addTaskModal').addEventListener('hidden.bs.modal', function () {
      keyboardListnerStatus(false);
    });
  });

  const confirmDraftStatus = getContext('confirmDraftStatus');
  const showDialog = getContext('showDialog');
  export const hide = (flag) => {
    if (addTaskModal != undefined) {
      confirmDraftStatus({
        show: flag == 'manual',
        okFunc: () => {
          addTaskModal.hide();
        },
      });
    }
  };
  let taskTemplateModal;
  const selectFromTemplate = (unitId, taskType, clients, unitProjectId) => {
    taskTemplateModal.show({ unitId, taskType, clients, unitProjectId });
  };
  const onSelectTemplate = (selectedTemplateId) => {
    taskTemplateModal.hide();
    addTaskDetail.onTemplateSelect(selectedTemplateId);
  };
</script>

<div
  class="modal fade font-size-13 slide-modal"
  id="addTaskModal"
  tabindex="-1"
  aria-labelledby="addTaskModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog add-task-modal h-100 m-0 float-end">
    <div class="modal-content">
      <div class="d-flex flex-column h-100">
        <div class="modal-header rounded-0">
          <h5 class="modal-title font-size-14">Create Task</h5>
          <button
            type="button"
            class="close btn-close"
            on:click={() => hide('manual')}
            aria-label="Close"
          >
            <span aria-hidden="true" />
          </button>
        </div>
        <TaskDetail
          bind:this={addTaskDetail}
          selectFromTemplate={selectFromTemplate}
        />
      </div>
    </div>
  </div>
</div>
<!-- Button trigger modal -->
<TaskTemplatesModal
  bind:this={taskTemplateModal}
  onSelectTemplate={onSelectTemplate}
/>
